import React, { useEffect } from "react";
import { withFormik } from "formik";
import { compose } from "recompose";
import cn from "classnames";
import TwoCellRow from "components/TwoCellRow";
import OrderItem from "components/OrderItem";
import CustomFormatNumber from "components/CustomFormatNumber";
import PrevButton from "components/PrevButton";
import NextButton from "components/NextButton";
import { orderTan } from "api";
import { useFormattedMessage, useSideModalScrollToTop } from "hooks";

const leftClass = "mb-9 d-block";
const rightClass = "text-14 fw-600 d-block mb-9";

const messages = {
    soEditOverviewMainHeading: "edit_sale_offer",
    editSalesOffer: "edit_sales_offer",
    boEditOverviewTileTitle: "overview",
    numberOfDigitalParts: "number_of_digital_shares",
    pricePerShare: "price_per_share",
    sellingPrice: "selling_price",
    sellingFee: "selling_fee",
    totalSalesPrice: "total_sales_price",
    soEditOverviewButtonText: "edit_publish_offer_now",
    soEditOverviewAcceptButtonText: "buy_now",
    shareShortText: "pc",
};

const SellOrderOverview = ({
    className = "",
    onBack,
    setCloseTitle,
    isOfferAccepted,
    errors,
    handleSubmit,
    stepData,
    isSubmitting,
    backSlideEffect = "",
}) => {
    useSideModalScrollToTop();

    const { formatMessage } = useFormattedMessage();

    useEffect(() => {
        setCloseTitle(formatMessage(messages.soEditOverviewMainHeading));
    }, []);

    return (
        <>
            <div className={`sell-order-edit-overview ${className} ${backSlideEffect}`}>
                <h3>{formatMessage(messages.editSalesOffer)}</h3>
                <h4 className="mt-10">{formatMessage(messages.boEditOverviewTileTitle)}</h4>
                <OrderItem
                    equalTitle={false}
                    orderFlag={stepData.flag}
                    tag={stepData.tag}
                    className={"mt-0 mb-10 border-active-red"}
                    image={stepData.projectImage}
                    title={stepData.projectTitle}
                    // city={stepData.projectCity}
                    shares={stepData.shares}
                    price={stepData.sellingPrice}
                    date={stepData.expirationDate}
                    perSharePrice={stepData.pricePerShare}
                />
                <div className="overview-details px-3">
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={formatMessage(messages.numberOfDigitalParts)}
                        right={
                            <>
                                <CustomFormatNumber
                                    value={stepData.shares}
                                    fixed="0"
                                    symbol={formatMessage(messages.shareShortText)}
                                />
                            </>
                        }
                    />
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={formatMessage(messages.pricePerShare)}
                        right={<CustomFormatNumber value={stepData.pricePerShare} />}
                    />
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={formatMessage(messages.sellingPrice)}
                        right={<CustomFormatNumber value={stepData.sellingPrice} />}
                    />
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={`${formatMessage(messages.sellingFee)} (${stepData.sellingFeePercent}%):`}
                        right={<CustomFormatNumber value={stepData.sellingFee} />}
                    />
                    <TwoCellRow
                        removeLClass
                        removeRClass
                        lClassname={leftClass}
                        rClassname={rightClass}
                        left={formatMessage(messages.totalSalesPrice)}
                        right={<CustomFormatNumber value={stepData.totalSalesPrice} />}
                    />
                </div>
            </div>
            <div className="bottom-bar-container single-button">
                <PrevButton disable={isSubmitting} onClick={onBack} />
                <NextButton
                    title={
                        isOfferAccepted
                            ? formatMessage(messages.soEditOverviewAcceptButtonText)
                            : formatMessage(messages.soEditOverviewButtonText)
                    }
                    className={cn({
                        "mw-100 btn-sell mr-1": true,
                        "disable-grey": isSubmitting || Object.keys(errors).length,
                    })}
                    onClick={handleSubmit}
                    disable={isSubmitting || Object.keys(errors).length}
                    isLoading={isSubmitting}
                />
            </div>
        </>
    );
};

export default compose(
    withFormik({
        handleSubmit: (values, { props, setSubmitting, setStatus }) => {
            try {
                setSubmitting(true);
                // setErrors({ requestError: undefined });

                const orderId = props?.stepData?.uid;

                orderTan(orderId)
                    .then((res) => {
                        res && setSubmitting(false);

                        if (res.data.errors) {
                            const error = res.data.errors[0].message;
                            setStatus({ requestError: error });
                            return;
                        }
                        return props.onForward();
                    })
                    .catch(() => {
                        setStatus({ requestError: true });
                        setSubmitting(false);
                    });
            } catch (error) {
                setStatus({ requestError: true });
                setSubmitting(false);
            }
        },
        displayName: "SellOrderOverview",
    })
)(SellOrderOverview);
